// Importando dependências
import React from 'react'
import {Input} from '../Input/Input'
import {Button} from '../Button/Button'

interface PrintIntegrationProps {
  config: {
    id?: number
    label: string
    name: string
  }
  printers: string[]
  selectedPrinter: string | null
  setSelectedPrinter: (printer: string) => void
  getPrinters: () => void
  loadingButton: boolean
}

// Componente PrintIntegration
const PrintIntegration: React.FC<PrintIntegrationProps> = ({
  config,
  printers,
  selectedPrinter,
  setSelectedPrinter,
  getPrinters,
  loadingButton,
}) => {
  const RenderRadioInput = () => (
    <div className='mt-2'>
      {printers.length === 0 && (
        <Button
          disabled={loadingButton}
          color='dark'
          text={'Buscar'}
          loading={loadingButton}
          click={getPrinters}
        />
      )}
      {printers.length > 0 && (
        <div>
          <h3 className='pb-2'>Selecione um Modelo Abaixo</h3>
          {printers.map((printer, index) => (
            <div key={index} style={{marginBottom: '10px'}}>
              <Input
                inputAttr={{
                  type: 'radio',
                  id: `printer-${index}`,
                  value: printer,
                }}
                checked={selectedPrinter === printer}
                label={printer}
                change={(checked: boolean) => {
                  if (checked) {
                    setSelectedPrinter(printer)
                  }
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )

  return (
    <div style={{flex: '40%'}} key={config.name}>
      <RenderRadioInput />
    </div>
  )
}

export default PrintIntegration
